// Uncomment the line below if you create a custom dictionary
// import { setupLocale } from "survey-core";

export var englishStrings = {
  pagePrevText: "Previous",
  pageNextText: "Next",
  completeText: "Complete",
  previewText: "Preview",
  editText: "Edit",
  startSurveyText: "Start",
  commentText: "Please leave a comment",
  otherItemText: "Other (describe)",
  noneItemText: "None",
  refuseItemText: "Refuse to answer",
  dontKnowItemText: "Don't know",
  selectAllItemText: "Select All",
  deselectAllItemText: "Deselect all",
  progressText: "Page {0} of {1}",
  indexText: "{0} of {1}",
  panelDynamicProgressText: "{0} of {1}",
  panelDynamicTabTextFormat: "Panel {panelIndex}",
  questionsProgressText: "Answered {0}/{1} questions",
  emptySurvey: "The survey doesn't contain any visible elements.",
  completingSurvey: "Thank you for completing the survey",
  completingSurveyBefore: "You have already completed this survey.",
  loadingSurvey: "Loading Survey...",
  placeholder: "Select...",
  ratingOptionsCaption: "Select...",
  buttongroupOptionsCaption: "Select...",
  value: "value",
  requiredError: "Response required.",
  requiredErrorInPanel: "Response required: answer at least one question.",
  requiredInAllRowsError: "Response required: answer questions in all rows.",
  eachRowUniqueError: "Each row must have a unique value.",
  numericError: "The value should be numeric.",
  minError: "The value should not be less than {0}",
  maxError: "The value should not be greater than {0}",
  textNoDigitsAllow: "Numbers are not allowed.",
  textMinLength: "Please enter at least {0} character(s).",
  textMaxLength: "Please enter no more than {0} character(s).",
  textMinMaxLength: "Please enter at least {0} and no more than {1} characters.",
  minRowCountError: "Please fill in at least {0} row(s).",
  minSelectError: "Please select at least {0} option(s).",
  maxSelectError: "Please select no more than {0} option(s).",
  numericMinMax: "The '{0}' should be at least {1} and at most {2}",
  numericMin: "The '{0}' should be at least {1}",
  numericMax: "The '{0}' should be at most {1}",
  invalidEmail: "Please enter a valid e-mail address.",
  invalidExpression: "The expression: {0} should return 'true'.",
  urlRequestError: "The request returned error '{0}'. {1}",
  urlGetChoicesError: "The request returned empty data or the 'path' property is incorrect",
  exceedMaxSize: "The file size should not exceed {0}.",
  noUploadFilesHandler: "Files cannot be uploaded. Please add a handler for the 'onUploadFiles' event.",
  otherRequiredError: "Response required: enter another value.",
  uploadingFile: "Your file is uploading. Please wait several seconds and try again.",
  loadingFile: "Loading...",
  chooseFile: "Choose file(s)...",
  noFileChosen: "No file selected",
  filePlaceholder: "Drag and drop a file here or click the button below to select a file to upload.",
  confirmDelete: "Are you sure you want to delete this record?",
  keyDuplicationError: "This value should be unique.",
  addColumn: "Add Column",
  addRow: "Add Row",
  removeRow: "Remove",
  noRowsText: "There are no rows.",
  rowIndexTemplateTitle: "Row {rowIndex}",
  rowNameTemplateTitle: "{rowTitle}",
  addPanel: "Add new",
  removePanel: "Remove",
  showDetails: "Show Details",
  hideDetails: "Hide Details",
  choices_Item: "item",
  choices_Choice: "Choice option",
  matrix_column: "Column",
  matrix_row: "Row",
  multipletext_itemname: "text",
  savingData: "The results are being saved on the server...",
  savingDataError: "An error occurred and we could not save the results.",
  savingDataSuccess: "The results were saved successfully!",
  savingExceedSize: "Your response exceeds 64KB. Please reduce the size of your file(s) and try again or contact the survey owner.",
  saveAgainButton: "Try again",
  timerMin: "min",
  timerSec: "sec",
  timerSpentAll: "You have spent {0} on this page and {1} in total.",
  timerSpentPage: "You have spent {0} on this page.",
  timerSpentSurvey: "You have spent {0} in total.",
  timerLimitAll: "You have spent {0} of {1} on this page and {2} of {3} in total.",
  timerLimitPage: "You have spent {0} of {1} on this page.",
  timerLimitSurvey: "You have spent {0} of {1} in total.",
  clearCaption: "Clear",
  selectCaption: "Select",
  signaturePlaceHolder: "Sign here",
  signaturePlaceHolderReadOnly: "No signature",
  chooseFileCaption: "Select File",
  takePhotoCaption: "Take Photo",
  photoPlaceholder: "Click the button below to take a photo using the camera.",
  fileOrPhotoPlaceholder: "Drag and drop or select a file to upload or take a photo using the camera.",
  replaceFileCaption: "Replace file",
  removeFileCaption: "Remove this file",
  booleanCheckedLabel: "Yes",
  booleanUncheckedLabel: "No",
  confirmRemoveFile: "Are you sure that you want to remove this file: {0}?",
  confirmRemoveAllFiles: "Are you sure that you want to remove all files?",
  questionTitlePatternText: "Question Title",
  modalCancelButtonText: "Cancel",
  modalApplyButtonText: "Apply",
  filterStringPlaceholder: "Type to search...",
  emptyMessage: "No data to display",
  loadingPage: "Loading...",
  loadingData: "Loading...",
  noEntriesText: "No entries yet.\nClick the button below to add a new entry.",
  noEntriesReadonlyText: "No entries",
  tabTitlePlaceholder: "New Panel",
  more: "More",
  tagboxDoneButtonCaption: "OK",
  selectToRankEmptyRankedAreaText: "All choices are selected for ranking",
  selectToRankEmptyUnrankedAreaText: "Drag choices here to rank them",
  ok: "OK",
  cancel: "Cancel",
  createCustomItem: "Create \"{0}\" item...",
  toc: "Table of contents",
  progressbar: "Progress bar",
};

// Uncomment the lines below if you create a custom dictionary.
// Replace "en" with a custom locale code (for example, "fr" or "de"),
// Replace `englishStrings` with the name of the variable that contains the custom dictionary.
//setupLocale({ localeCode: "en", strings: englishStrings, nativeName: "English", englishName: "English" });
